import { render, staticRenderFns } from "./OrganizationPointOfContactTable.vue?vue&type=template&id=f09e7274&"
import script from "./OrganizationPointOfContactTable.vue?vue&type=script&lang=ts&"
export * from "./OrganizationPointOfContactTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports